import React, { useContext } from 'react';
import { Box, BoxProps } from '@mui/material';
import { UiContext } from 'shared/lib/contexts/uiContext';

export default function SectionsContainer(props: BoxProps) {
  const {
    spacings: { sp },
  } = useContext(UiContext);

  return (
    <Box
      {...props}
      sx={{
        display: 'flex',
        flexDirection: 'column',
        gap: sp.s120,
        ...props.sx,
      }}
    ></Box>
  );
}
